import { render, staticRenderFns } from "./ProcedingsFilter.vue?vue&type=template&id=07368088&"
import script from "./ProcedingsFilter.vue?vue&type=script&lang=js&"
export * from "./ProcedingsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports